import { gql } from "@apollo/client";
import { produce } from "immer";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "moment-timezone";
import { nameOf } from "../../utils/object.js";
import "react-intl";
class PlayerBonusRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildQuery(fields) {
    return gql`
            query GetPlayerBonuses($filter: PlayerBonusesFilter, $sort: Sorting, $start: Int, $end: Int) {
                getPlayerBonuses(filter: $filter, sort: $sort, end: $end, start: $start) {
                    items {
                        bonus_id
                        uid @include(if: ${this.hasField(fields, "uid")})
                        bonus_engine_code @include(if: ${this.hasField(fields, "bonus_engine_code")})
                        bonus_status @include(if: ${this.hasField(fields, "bonus_status")})
                        marketing_code @include(if: ${this.hasField(fields, "marketing_code")})
                        bonus_name @include(if: ${this.hasField(fields, "bonus_name")})
                        desc @include(if: ${this.hasField(fields, "desc")})
                        total_amount @include(if: ${this.hasField(fields, "total_amount")})
                        realized_amount @include(if: ${this.hasField(fields, "realized_amount")})
                        created_at @include(if: ${this.hasField(fields, "created_at.seconds")}) {
                            seconds
                        }
                        expire_at @include(if: ${this.hasField(fields, "expire_at.seconds")}) {
                            seconds
                        }
                        type @include(if: ${this.hasField(fields, "type")})
                    }
                    total_count
                }
            }
        `;
  }
  buildFilter(filter) {
    const updatedFilter = produce(filter, (draftState) => {
      draftState.desc = "!(MTT Ticket)";
    });
    return {
      filter: {
        text: this.getGQLTextFilter(
          Object.keys(this.filterFieldsMapper).map(
            (key) => this.toGQLTextFilter(this.filterFieldsMapper[key], updatedFilter[key])
          )
        ),
        type: this.toGQLMultiselectFilter(updatedFilter, "type")
      }
    };
  }
  filterFieldsMapper = {
    uid: [nameOf("uid")],
    bonus_engine_code: [nameOf("bonus_engine_code")],
    desc: [nameOf("desc")]
  };
}
export {
  PlayerBonusRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
